import styled, { css } from 'styled-components'

import {
    FlexCentered,
    AbsolutePositioning,
    RowFlex,
} from 'components/common/genericStyles'

import { isCorrectOrIncorrect } from './helper'

import {
    colors,
    assetsBase,
    responseTypes,
    tabDesktopBreakpoint,
} from '../../constants'

const ConfettiImage = `${assetsBase}/confetti.svg`

const getBackgroundColor = props =>
    props.$type === responseTypes.CORRECT
        ? colors.secondaryGreen
        : props.$type === responseTypes.INCORRECT
        ? colors.secondaryRed
        : 'rgba(0, 0, 0, 0.12)'

const getColor = props =>
    isCorrectOrIncorrect(props.$type) ? '#fff' : 'rgba(0, 0, 8, 0.8)'

const getTextShadow = props =>
    isCorrectOrIncorrect(props.$type)
        ? '3.68182px 3.68182px 0px rgba(0, 0, 0, 0.75)'
        : '3.68182px 3.68182px 0px rgba(255, 255, 255, 0.75)'

export const Container = styled.div`
    width: 100%;
    height: 30%;
    ${FlexCentered};
    background-color: ${props => getBackgroundColor(props)};
    color: ${props => getColor(props)};
    border-radius: 8px 8px 0px 0px;
    flex-direction: column;

    @media (orientation: landscape) {
        height: 40%;
    }

    /* Tablets & up */
    @media (min-width: ${tabDesktopBreakpoint}px) {
        position: relative;
        height: 30%;
        border-radius: 0px;

        z-index: 2;

        ${props =>
            props.$type === responseTypes.CORRECT &&
            css`
                background-image: url(${ConfettiImage}), url(${ConfettiImage});
                background-position: top left, bottom right;
                background-repeat: no-repeat;
            `}
    }
`

export const BannerContainer = styled.div`
    ${RowFlex};
    justify-content: center;
    align-items: flex-end;

    width: inherit;
    flex-grow: 1;
    .title {
        font-size: 24px;
        text-align: center;
    }

    padding-bottom: 5%;

    text-shadow: ${props => getTextShadow(props)};

    /* Tablets & up */
    @media (min-width: ${tabDesktopBreakpoint}px) {
        align-items: center;
        padding-bottom: unset;
        ${props =>
            props.$isTeacher &&
            css`
                justify-content: flex-start;
                padding: 3.3vh 2.77vw;
            `}

        .title {
            font-size: 48px;
        }
    }
`

export const PointsContainer = styled.div`
    ${FlexCentered};
    width: inherit;
    background: ${props => getBackgroundColor(props)};
    height: 32px;
    font-size: 16px;

    /* Tablets & up */
    @media (min-width: ${tabDesktopBreakpoint}px) {
        ${({ $isTeacher }) =>
            $isTeacher &&
            css`
                justify-content: flex-start;
                padding: 0 2.77vw;
            `}
        height: 37px;
        font-size: 20px;
    }
`

export const IconContainer = styled.div`
    width: 40px;
    height: 40px;
    margin-right: 15px;
    background: ${colors.primaryWhite};
    border: 1px solid #000000;
    box-sizing: border-box;
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.75);
    border-radius: 50%;
    ${FlexCentered}

    /* Tablets & up */
    @media (min-width: ${tabDesktopBreakpoint}px) {
        width: 50px;
        height: 50px;
        margin: 5px 15px 0px 0px;
    }
`

export const Image = styled.img`
    width: 65%;
    height: 65%;
`

export const LottieContainer = styled.div`
    display: none;

    /* Tablets & up */
    @media (min-width: ${tabDesktopBreakpoint}px) {
        display: block;
        ${AbsolutePositioning}
        z-index: 1;
    }
`

export const QuestionStatistics = styled.div`
    ${FlexCentered}
`

export const ResponseType = styled.div`
    ${FlexCentered}
    margin-right: 11px;
`

export const Indicator = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 4px;
    margin-right: 4px;
    background: ${({ category }) =>
        category === responseTypes.CORRECT
            ? '#089864'
            : category === responseTypes.INCORRECT
            ? '#D9435E'
            : '#C4C4C4'};
`
